import { createApp } from 'vue'
import App           from "./components/App.vue";
//import store         from "./store";
import { createStore } from "vuex"

function onReady ()
{

    const quizzes = document.querySelectorAll( '.block-quiz' );

    if ( quizzes.length === 0 )
    {
        return;
    }

    // document.querySelector( 'body' ).classList.add( 'has-incomplete-quiz' );

    Array.from( quizzes ).forEach( ( el, i ) =>
    {

        const vueQuiz = createApp( App );

        let strQuizData = `__quiz_${el.dataset.quizId}__`;
        let jsonQuiz    = window[ strQuizData ];

        let objStore = createNewStore(); //si on fait pas ca, on peut pas avoir multiple quiz dans une page
        let quizStore = createStore(objStore);

        vueQuiz
            .provide( 'quizContainer', el )
            .provide( 'quiz', jsonQuiz )
            .provide( 'copydeck', __copydeck__.quiz )
            .provide( 'quizReactions', __quiz_reactions__ )
            .use( quizStore )
            .mount( el )
            .name = "Quiz Module";

    } );
}


function createNewStore ()
{
    let state =
            {
                ready         : false,
                quiz          : [],
                rightAnswers  : 0,
                copydeck      : {},
                quizReactions : [],
                userAnswers   : {},

            };

    let getters =
            {
                userAnswers ( state )
                {
                    return state.userAnswers;
                },
            };


    let actions =
            {}


    let mutations =
            {

                ready ( state )
                {
                    state.ready = true;
                },

                copydeck ( state, payload )
                {
                    state.copydeck = payload;
                },

                quiz ( state, payload )
                {
                    state.quiz = payload;
                },

                rightAnswer ( state )
                {
                    state.rightAnswers++;
                },

                quizReactions ( state, payload )
                {
                    state.quizReactions = payload;
                },

                userAnswers ( state, payload )
                {
                    state.userAnswers = payload;
                },
            }


            return { state, getters, actions, mutations }
}


document.addEventListener( 'DOMContentLoaded', onReady );

// console.log( 'quiz.js is in da house' );
